import styles from "./ContentTitle.module.css";

interface ContentTitleProps {
    title: string;
    keyword?: string;
    count?: number;
}

/**
 * @author bakim
 * @date 2024-09-11 14:09:24
 * @remark 지도 시트 내 제목 컴포넌트
 * @param {string} title(required) : 제목
 * @param {string} keyword?: 키워드(필터링 키워드);
 * @param {number} count?: 목록 내 데이터 개수;
 */
function ContentTitle(props: ContentTitleProps) {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <span>{props.keyword && `${props.keyword} `}</span>
                {props.title}
            </div>
            <div className={styles.count}>{props.count && props.count}</div>
        </div>
    );
}

export default ContentTitle;
